import { PropsWithChildren } from "react";
import { usePopover } from "../../../store/onboarding/onboardingSlice";
import { ClickButton } from "../../../components/Buttons";

const HubAddBoxPopover: React.FC<PropsWithChildren> = ({ children }) => {
    const { popoverData, displayPopover, nextPopover, Popover } = usePopover("self-hosted-hub");

    return (
        <Popover
            title={popoverData?.title as string}
            text={popoverData?.text as string}
            position={popoverData?.position as PositionProps}
            content={
                <ClickButton variant="primary" text="Next" onClick={() => {
                    nextPopover();
                }} />
            }
            counter={4}
            className="hub__container"
            display={displayPopover}
        >
            {children}
        </Popover>
    );
};

export default HubAddBoxPopover;
